import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Quill = ReactQuill.Quill;
const SizeStyle = Quill.import('attributors/style/size');
const FontStyle = Quill.import('attributors/style/font');
SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px'];
FontStyle.whitelist = ['arial', 'verdana', 'tahoma', 'georgia', 'times', 'courier'];
Quill.register(SizeStyle, true);
Quill.register(FontStyle, true);

const toolbar = [
  [{ header: [1, 2, 3, false] }],
  [{ font: FontStyle.whitelist }, { size: SizeStyle.whitelist }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
  ['link', 'image'],
  ['clean']
];

const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'list',
  'bullet',
  'indent',
  'align',
  'link',
  'image'
];

const RichTextEditor = ({ input, placeholder }) => {
  const quillRef = useRef(null);

  const uploadInlineImage = () => {
    const fileInput = document.createElement('input');
    fileInput.setAttribute('type', 'file');
    fileInput.setAttribute('accept', 'image/png,image/jpeg,image/jpg,image/gif,image/webp');

    fileInput.onchange = () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onload = event => {
        const quillEditor = quillRef.current ? quillRef.current.getEditor() : null;
        const imageUrl = event && event.target ? event.target.result : null;
        if (!quillEditor || !imageUrl) {
          return;
        }
        const range = quillEditor.getSelection(true);
        const index = range ? range.index : quillEditor.getLength();
        quillEditor.insertEmbed(index, 'image', imageUrl, 'user');
        quillEditor.setSelection(index + 1);
      };
      reader.readAsDataURL(file);
    };

    fileInput.click();
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: toolbar,
      handlers: {
        image: uploadInlineImage
      }
    }
  }), []);

  return (
    <div className="rsl-rich-text-editor">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={input.value || ''}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

RichTextEditor.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  }).isRequired,
  placeholder: PropTypes.string
};

export default RichTextEditor;
